import { render } from "./Progressbar.vue?vue&type=template&id=0c706c46"
import script from "./Progressbar.vue?vue&type=script&lang=js"
export * from "./Progressbar.vue?vue&type=script&lang=js"

import "./Progressbar.vue?vue&type=style&index=0&id=0c706c46&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__